import {useQuery} from "react-query";
import folderService from "../../services/FolderService";

export default function useFolderChain(id?: number) {
   return useQuery(['folder-chain', id], () => folderService.getFolderChain(id), {
      enabled: !!id
   });
}